<div class="row margin-top-20">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="border-div">
      <div class="d-flex chart-box-header margin-bottom-30 align-item-center">
        <h2 class="mainhead mr-auto mainhead2"><span class="text">B+E Market Snapshot</span></h2>
        <div class="like-view-div  margin-right-20">
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" *ngIf="highlightData!=null&&highlightData.length>0">
                <div class="be-market-hlts-wrapper">
                  <div class="d-flex margin-bottom-20">
                    <div>
                      <h5 class="bluelabel margin-bottom-0 myPortfolioNormalHeading">Cap Rate Highlights</h5>
                    </div>
                    <div class="leftside ml-auto ">
                      <label class="select margin-left-a">
                        <select class="form-control" [(ngModel)]="selectedDuration" (change)="getHighlight();" style="width:175px">
                          <option value="1">Last 1 Month</option>
                          <option value="3">Last 3 Months</option>
                          <option value="6">Last 6 Months</option>
                        </select>
                        <i></i>
                      </label>
                    </div>
                  </div>
                  <div class="margin-top-10 d-flex be-market-hlts flex-wrap">
                    <div class="{{(highlight!=null&&(highlight.name=='My Portfolio'||highlight.name=='Portfolio'))?'be-market-data-box my-portfolio-card':'be-market-data-box'}}" *ngFor="let highlight of highlightData;let j = index">
                      <div class="d-flex flex-direction-colum flex-1 market-snapshot-box">
                        <p class="label margin-bottom-5">{{highlight.name!=null?highlight.name:''}}</p>
                        <div class="d-flex in-box-t" *ngIf="highlight.StatusId!=null&&highlight.StatusId==1">
                          <span class="in-box">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path fill="#6A7175" d="M9 0C4.027 0 0 4.027 0 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9Zm0 2.25L15.75 9 9 15.75v-4.5H2.25v-4.5H9v-4.5Z" /></svg>
                          </span>
                          <p class="margin-left-10 m-data 1">
                            {{highlight.currentValue!=null&&highlight.currentValue>0?(highlight.currentValue|number : '1.2-2'):'0.00'}} % <br />
                            <span class="gray-color">
                              <i container="body" class="userpermissiontooltip" triggers="mouseenter:mouseleave" aria-hidden="true" popover="{{(highlight.InfoText)}}" popoverTitle="{{(highlight.name!=null?highlight.name:'')+' Cap Rate Info'}}" placement="right">
                                <img src="/assets/img/info-icon-blue.svg" class="info-icon-blue-position">
                              </i>
                              {{highlight.difference!=null&&highlight.difference>0?(highlight.difference|number : '1.2-2'):'0.00'}} %
                            </span>
                          </p>
                        </div>
                        <div class="d-flex gray-d-flex-box" *ngIf="highlight.StatusId!=null&&highlight.StatusId==0">
                          <span class="in-box">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path fill="#6A7175" d="M9 0C4.027 0 0 4.027 0 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9Zm0 2.25L15.75 9 9 15.75v-4.5H2.25v-4.5H9v-4.5Z" /></svg>
                          </span>
                          <p class="margin-left-10 m-data 0">
                            {{highlight.currentValue!=null&&highlight.currentValue>0?(highlight.currentValue|number : '1.2-2'):'0.00'}} % <br />
                            <span class="gray-color">
                              <i container="body" class="userpermissiontooltip" triggers="mouseenter:mouseleave" aria-hidden="true" popover="{{(highlight.InfoText)}}" popoverTitle="{{(highlight.name!=null?highlight.name:'')+' Cap Rate Info'}}" placement="right">
                                <img src="/assets/img/info-icon-blue.svg" class="info-icon-blue-position">
                              </i>
                              {{highlight.difference!=null&&highlight.difference>0?(highlight.difference|number : '1.2-2'):'0.00'}} %
                            </span>
                          </p>
                        </div>
                        <div class="d-flex in-box-d" *ngIf="highlight.StatusId!=null&&highlight.StatusId!=1&&highlight.StatusId!=0">
                          <span class="in-box">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path fill="#6A7175" d="M9 0C4.027 0 0 4.027 0 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9Zm0 2.25L15.75 9 9 15.75v-4.5H2.25v-4.5H9v-4.5Z" /></svg>
                          </span>
                          <p class="margin-left-10 m-data 2">
                            {{highlight.currentValue!=null&&highlight.currentValue>0?(highlight.currentValue|number : '1.2-2'):'0.00'}} % <br />
                            <span class="gray-color">
                              <i container="body" class="userpermissiontooltip" triggers="mouseenter:mouseleave" aria-hidden="true" popover="{{(highlight.InfoText)}}" popoverTitle="{{(highlight.name!=null?highlight.name:'')+' Cap Rate Info'}}" placement="right">
                                <img src="/assets/img/info-icon-blue.svg" class="info-icon-blue-position">
                              </i>
                              {{highlight.difference!=null&&highlight.difference>0?(highlight.difference|number : '1.2-2'):'0.00'}} %
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 padding-left-65">
                <h5 class="graylabel margin-bottom-15 margin-top-0" *ngIf="IschartLoaded==1">Average Cap Rates</h5>
                <div id="MarketSnapShotChart"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="(showLoader!=null&&!showLoader)&&(barchartData==null||barchartData?.length ==0)">
          <div class="nodata col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <i class="fa fa-exclamation-triangle icon"></i>

          </div>
        </div>
        <div class="row" *ngIf="showLoader!=null&&showLoader">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 d-felx">
            <div class="be-loader-smal m-auto" style="min-height:200px">
              <div class="m-auto be-loader-inner">
                <div class="circle-loader"></div>
                <p class="margin-t-10">Market Data Loading...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>





